<script setup>
import { useFormStore } from '@/stores/form'
import FormControlPlainText from "@/common/form-control/FormControlPlainText.vue"

const props = defineProps({
    formId: String,
    currentData: Object,
    field: Object,
})

// Instantiate dynamic Pinia Form Store
const formStore = useFormStore(props.formId)

// Emulating the created hook logic
formStore.setDefaultValue({
    name: props.field.name,
    value: ''
})
</script>

<template>
    <FormControlPlainText v-if="field.readonly" :value="currentData[field.name]" :form-id="formId"/>
    <input v-else :id="field.id" v-model="currentData[field.name]" v-select="field.autofocus" :disabled="field.disabled"
           :max="field.max" :min="field.min" :name="field.name" :step="field.step" autocomplete="off" type="range">
</template>